import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SocialService } from '../../../../../../common/services/Social.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../../../../environments/environment';
import { DEFAULT_ACCEPTED_CONTENT, ZaloConst } from './zalo.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import { BsModalService } from 'ngx-bootstrap';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import * as _ from 'lodash';
import { BaseListComponent } from '../../../../../../components/base-list.component';

const ZALO_URL = environment.url_ottgateway;
const APP_ID = environment.app_zalo_id;

@Component({
  selector: 'settings-conversation-zalo',
  templateUrl: './zalo.component.html',
  styleUrls: ['./zalo.component.css'],
  providers: [SocialService],
})
export class ZaloComponent extends BaseListComponent {
  popupWindow: Window | null = null;

  @ViewChild('znsTemplate') znsTemplate: ElementRef;

  public list: any = [];
  public pages: any = [];
  public access_token: any;
  public modalRef2: any;
  public no_image: any = 'assets/images/img_notfound.png';
  public displayZnsColumns: any = [];
  public active_zns = true;
  public is_config = false;
  public titleConfigOa = '';
  public typeModalZns = 'add';
  public modelFilter: any = {};
  public targetOa = '';

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected modalService: BsModalService,
    protected toastr: ToastrService,
    private socialService: SocialService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = ZaloConst.displayColumns();
    this.displayZnsColumns = ZaloConst.displayZnsColumns();
  }

  ngOnInit() {
    this.loadPage();
  }

  setData(res) {
    this.list = res.data.list;
    this.list.map(e => {
      e.is_valid = ZaloConst.displayValidColumns(e.is_valid);
      return e;
    });
    this.initPage(res.data.total);
  }

  async loadPage(request: any = {}, sort: any = {}) {
    this.list = [];
    request.type = 0;
    const payload = await this.buildBasePayload(request, sort);
    this.socialService.listPageV2(payload).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.setData(res);
      } else {
        this.list = [];
      }
    });
  }

  async loadZns(page_id, request: any = {}, sort: any = {}) {
    this.is_config = true;
    this.list = [];
    request.page_id = page_id;
    const payload = await this.buildBasePayload(request, sort);
    this.socialService.listZnsTemplate(payload).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.setData(res);
      } else {
        this.list = [];
      }
    });
  }

  deletePage(page_id) {
    const y = confirm('Bạn có muốn xóa trang này không?');
    if (y) {
      this.socialService.deletePageV2(page_id).subscribe(res => {
        if (!res.error && res.status == 200) {
          this.throwSuccess('Xóa page thành công!');
          this.loadPage();
        }
      });
    }
  }
  login() {
    window.open(ZALO_URL + '/zalologin.html?access_token=' + localStorage.getItem('Access-Token'), '_blank');
  }

  handleAction(type: any, item?: any) {
    switch (type) {
      case TableAction.add:
        this.loginWithZalo();
        break;
      case TableAction.delete:
        this.deletePage(item.page_id);
        break;
      case TableAction.config:
        this.titleConfigOa = item.page_name;
        this.targetOa = item.page_id;
        this.loadZns(item.page_id);
        break;
    }
  }

  async loginWithZalo() {
    const redirectUrl = window.location.protocol + '//' + window.location.host + '/zalo-redirect';
    const state = this.user.tenant_id + '_' + this.user._id;
    this.popupWindow = window.open(
      'https://oauth.zaloapp.com/v4/oa/permission?app_id=' +
        APP_ID +
        '&redirect_uri=' +
        redirectUrl +
        '&state=' +
        state,
      '_blank',
      'width=600,height=400'
    );
    // Add event listener to handle data from popup window
    window.addEventListener('message', this.callbackLogin.bind(this), false);
  }

  callbackLogin(event: MessageEvent) {
    if (event.source === this.popupWindow && event.data) {
      console.log('Received data from popup:', event.data);
      this.loadPage();
    }
  }

  openModalZns(type, item?: any) {
    this.typeModalZns = type;
    if (item) {
      this.model = {
        oa_id: this.targetOa,
        _id: item._id,
        name: item.name,
        template_id: item.template_id,
        type: 1,
        note: item.note,
        content: item.content,
        key: item.key,
      };
    } else {
      this.model = {
        oa_id: this.targetOa,
        name: '',
        template_id: '',
        type: 1,
        note: '',
        content: '',
        key: [],
      };
    }
    this.modelContent = {
      type: ModalType.Primary,
      title: type == 'edit' ? 'Cập nhật kịch bản ZNS' : 'Tạo mới kịch bản ZNS',
      submit_title: type == 'edit' ? 'Cập nhật' : 'Thêm mới',
    };
    this.modelDisplay = [
      {
        key: 'name',
        label: 'Tên kịch bản',
        type: FormFieldType.Text,
        value: this.model.name,
        required: true,
        disabled: false,
        width: '1/2',
        order: 0,
      },
      {
        key: 'template_id',
        label: 'ID kịch bản',
        value: this.model.template_id,
        type: FormFieldType.Text,
        required: true,
        disabled: type == 'edit',
        width: '1/2',
        order: 1,
      },
      {
        key: 'note',
        label: 'Mô tả',
        type: FormFieldType.Textarea,
        value: this.model.note,
        required: false,
        disabled: false,
        width: 'full',
        order: 2,
        options: { class: 'mh-100' },
      },
      {
        key: 'content',
        label: 'Nội dung',
        type: FormFieldType.Textarea,
        value: this.model.content,
        required: true,
        disabled: false,
        width: 'full',
        order: 3,
        options: { class: 'mh-150' },
      },
      {
        key: 'note_content',
        label: '',
        type: FormFieldType.Note,
        value: `<span class="mb-2 text-muted">Điền nội dung tương ứng với Template ID. Lưu ý: Tên biến được đặt trong dấu {{}}, ví dụ {{name}}.</span>`,
        order: 4,
      },
    ];

    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-lg',
    };
    this.openModal(this.znsTemplate, config, this.model, {
      modelContent: this.modelContent,
      modelDisplay: this.modelDisplay,
    });
  }

  mapKeyZns(value) {
    const regex = /{{(.*?)}}/g;
    const matches = [];
    let match;
    while ((match = regex.exec(value)) !== null) {
      matches.push(match[1]);
    }
    this.model.key = matches;
  }

  async fetchZnsTemplate(_id?: any) {
    this.message = null;
    delete this.model.note_content;
    if (!_id) {
      this.socialService.createZnsTemplate(this.model).subscribe(
        res => {
          if (!res.error && res.status == 200) {
            this.throwSuccess('Thêm mới thành công!');
            this.loadZns(this.targetOa);
            this.closeModal();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    } else {
      delete this.model._id;
      this.socialService.updateZnsTemplate(_id, this.model).subscribe(
        res => {
          if (!res.error && res.status == 200) {
            this.throwSuccess('Cập nhật thành công!');
            this.loadZns(this.targetOa);
            this.closeModal();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }

  deleteZns(_id?: any): void {
    const y = confirm('Bạn có muốn xóa kịch bản ZNS không?');
    let ids = [];
    if (_id) {
      ids = [_id];
    } else {
      ids = this.lstChecked;
    }
    if (y) {
      this.socialService.deleteZnsTemplate({ ids: ids }).subscribe(
        res => {
          if (!res.error && res.status == 200) {
            const { total, success, failure } = res.data;
            if (success > 0) {
              this.throwSuccess(`Xóa thành công ${success} kịch bản ZNS!`, 'Thông báo');
            }
            if (failure > 0) {
              this.throwWarning(`Xóa thất bại ${failure} kịch bản ZNS! Do kịch bản đang được sử dụng!`, 'Cảnh báo');
            }
            this.loadZns(this.targetOa);
          } else {
            this.throwError(res.message);
          }
        },
        error => {
          this.throwError(error.message);
        }
      );
    }
  }

  handleZnsAction(type: any, item?: any) {
    switch (type) {
      case TableAction.add:
        this.openModalZns('add');
        break;
      case TableAction.edit:
        this.openModalZns('edit', item);
        break;
      case TableAction.delete:
        this.deleteZns(item._id);
        break;
      case TableAction.deleteAll:
        this.deleteZns();
        break;
    }
  }

  handleSubmitZns(item?: any) {
    this.model = _.merge({}, this.model, item);
    this.mapKeyZns(this.model.content);
    switch (this.typeModalZns) {
      case 'add':
        this.fetchZnsTemplate();
        break;
      case 'edit':
        this.fetchZnsTemplate(this.model._id);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/zalo/zalo.component.ts